import {
  CANVAS_FRONT_DIMENSIONS,
  getBleed,
  isAIGenPhoto,
  MATERIAL_TYPES,
  type TILE_CONTENT,
  type TILE_SIZES,
} from '@mixtiles/web-backend-shared'
import type { ExperimentManager } from '../services/ExperimentManager/ExperimentManager'

type TileContent = (typeof TILE_CONTENT)[keyof typeof TILE_CONTENT]

export function isCanvasGenerativeWrap({
  materialType,
  tileContent,
  experimentManager,
}: {
  materialType: MATERIAL_TYPES
  tileContent?: TileContent
  experimentManager: ExperimentManager
}): boolean {
  return (
    materialType === MATERIAL_TYPES.CANVAS &&
    isAIGenPhoto({ tileContent }) &&
    experimentManager.isEnabled('canvas-generative-wrap')
  )
}

function getCanvasPageGeometry(tileSize: TILE_SIZES) {
  const { width: frontWidth, height: frontHeight } =
    CANVAS_FRONT_DIMENSIONS[tileSize]
  const { bleedWidth, bleedHeight } = getBleed({
    tileSize,
    materialType: MATERIAL_TYPES.CANVAS,
  })

  return {
    frontWidth,
    frontHeight,
    bleedWidth,
    bleedHeight,
  }
}

export function getCanvasFrontAspectRatio(tileSize: TILE_SIZES): number {
  const { frontWidth, frontHeight } = getCanvasPageGeometry(tileSize)
  return frontWidth / frontHeight
}

export function getCanvasWrapDepthRatio(tileSize: TILE_SIZES) {
  const { frontWidth, frontHeight, bleedWidth, bleedHeight } =
    getCanvasPageGeometry(tileSize)
  return { x: bleedWidth / frontWidth, y: bleedHeight / frontHeight }
}
